<ng-template #template_ref_delete>
	<div class="modal-body text-center">
		<p>{{"delete_dialogue"|translate}}</p>
		<button type="button" class="btn btn-primary btn-circle" (click)="delete()" title="{{'confirm'|translate}}"><i class="fa fa-check"></i></button>
		<button type="button" class="btn btn-warning btn-circle" (click)="hideModal('delete')" title="{{'abort'|translate}}"><i class="fa fa-remove"></i></button>
	</div>
</ng-template>

<div ui-view="" class="ng-scope">
	<div class="wrapper wrapper-content animated fadeIn ng-scope">
		<div class="row">
			<div class="col-lg-12" *ngIf="!deleted">
				<div class="ibox-title">
					<h5>{{"detail_view"|translate}} {{helper_service.getLabelName(detail_config)|translate}}</h5>
					<div class="ibox-tools">
						<button type="button" class="btn btn-primary btn-circle" (click)="duplicate()" title="{{'duplicate'|translate}}" *ngIf="detail_config.allowduplicate"><i class="fa fa-copy"></i></button>
						<button type="button" class="btn btn-danger btn-circle tig-mr20" (click)="openModal(template_ref_delete, 'delete')" title="{{'delete'|translate}}" *ngIf="detail_config.allowdelete && !new"><i class="fa fa-trash-o"></i></button>
						<button type="button" class="btn btn-default bg-muted btn-circle tig-mr6" (click)="goBack()" title="{{'back'|translate}}"><i class="fa fa-reply"></i></button>
						<button type="button" class="btn btn-primary btn-circle" (click)="save()" title="{{'save'|translate}}" *ngIf="detail_config.allowsave" [disabled]="save_button_deactivated"><i class="fa fa-save"></i></button>
					</div>
				</div>
				<div class="ibox-content">
					<tabset #tabset>
						<tab>
							<ng-template tabHeading><i class="fa tig-{{detail_config.title.toLowerCase()}}"></i><span class="tig-title">{{helper_service.getLabelName(detail_config)|translate}}</span></ng-template>
							<h4 class="tig-title">{{helper_service.getLabelName(detail_config)|translate}}</h4>
							<tig-dynamic-form
									[ARR_form_fields]="detail_config.fields"
									[OBJ_parent_group]="main_form_group"
									[STR_form_group_name]="'main'">
							</tig-dynamic-form>
						</tab>
						<ng-container *ngFor="let field of detail_config.fields">

							<tab *ngIf="field.type === 'iframe' && field.value?.length > 0" (selectTab)="showIframe()">
								<ng-template tabHeading><i class="fa tig-{{field.name.toLowerCase()}}"></i><span class="tig-title">{{helper_service.getLabelName(field)|translate}}</span></ng-template>
								<h4 class="tig-title">{{helper_service.getLabelName(field)|translate}}</h4>
								<div class="tig-iframe">
									<div class="ibox-tools">
										<button type="button" class="btn btn-default bg-muted btn-circle" (click)="changeIframe(iframe, 'tig-website')" title="{{'desktop'|translate}}"><i class="fa fa-desktop fa-shift"></i></button>
										<button type="button" class="btn btn-default bg-muted btn-circle" (click)="changeIframe(iframe, 'tig-phone')" title="{{'mobile'|translate}}"><i class="fa fa-mobile"></i></button>
										<button type="button" class="btn btn-default bg-muted btn-circle" (click)="changeIframe(iframe, 'tig-tablet')" title="{{'tablet'|translate}}"><i class="fa fa-tablet"></i></button>
									</div>
									<br/>
									<div class="clear"></div>
									<!-- default is desktop width -->
									<iframe #iframe class="tig-default" width="100%" height="90%" frameborder="0" allowfullscreen [src]="field.value|safe"></iframe>
								</div>
							</tab>

							<tab *ngIf="(field.type === 'datatable') && field.value?.length > 0">
								<ng-template tabHeading><i class="fa tig-{{field.name.toLowerCase()}}"></i><span class="tig-title">{{helper_service.getLabelName(field)|translate}}</span></ng-template>
								<h4 class="tig-title">{{helper_service.getLabelName(field)|translate}}</h4>
								<div class="table-responsive">
									<div id="DataTables_Table_0_wrapper" class="dataTables_wrapper form-inline dt-bootstrap">
										<table class="table table-bordered">
											<thead>
											<tr>
												<th *ngFor="let key of objectKeys(field.value[0])">{{key|translate}}</th>
											</tr>
											</thead>
											<tbody>
											<tr *ngFor="let entry of field.value">
												<td *ngFor="let key of objectKeys(entry)">{{entry[key] | json}}</td>
											</tr>
											</tbody>
										</table>
									</div>
								</div>
							</tab>

							<tab *ngIf="(field.type === 'sequential_array') && field.value?.length > 0">
								<ng-template tabHeading>
									<i class="fa tig-{{field.name.toLowerCase()}}"></i>
									<span class="tig-title">{{helper_service.getLabelName(field)|translate}}</span>
								</ng-template>
								<h4 class="tig-title">{{helper_service.getLabelName(field)|translate}}</h4>
								<div class="table-responsive">
									<div class="dataTables_wrapper form-inline dt-bootstrap">
										<table class="table table-bordered">
											<tbody>
												<tr *ngFor="let entry of field.value">
													<td>{{entry | json}}</td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
							</tab>

							<tab *ngIf="field.type === 'object_array'">
								<ng-template tabHeading>
									<i class="fa tig-{{field.name.toLowerCase()}}"></i>
									<span class="tig-title">{{helper_service.getLabelName(field)|translate}}</span>
								</ng-template>
								<h4 class="tig-title">{{helper_service.getLabelName(field)|translate}}</h4>
								<tig-tabs-object-array [OBJ_field]="field" [BOO_allow_delete]="detail_config.allowdelete" [OBJ_parent_form_group]="main_form_group" [STR_form_group_name]="field.name"></tig-tabs-object-array>
							</tab>

							<tab *ngIf="(field.type === 'datatable_editable')">
								<ng-template tabHeading><i class="fa tig-{{field.name.toLowerCase()}}">
									</i><span class="tig-title">{{helper_service.getLabelName(field)|translate}}</span>
								</ng-template>
								<tig-datatable-editable [OBJ_config_fields]="field" [OBJ_parent_form_group]="main_form_group" [STR_form_group_name]="field.name"></tig-datatable-editable>
							</tab>

							<tab *ngIf="(field.type === 'assignments_editable')">
								<ng-template tabHeading>
									<i class="fa tig-{{field.name.toLowerCase()}}"></i>
									<span class="tig-title">{{helper_service.getLabelName(field)|translate}}</span>
								</ng-template>
								<tig-assignments-editable [OBJ_config_fields]="field" [OBJ_parent_form_group]="main_form_group" [STR_form_group_name]="field.name"></tig-assignments-editable>
							</tab>

							<tab *ngIf="(field.type === 'array' || field.type === 'publicationobjects')">
								<ng-template tabHeading><i class="fa tig-{{field.name.toLowerCase()}}"></i><span class="tig-title" [ngClass]="{'tgi-new': field.new}">{{helper_service.getLabelName(field)|translate}}</span></ng-template>
								<tig-tabs-publicationobjects [OBJ_field_config]="field" [ARR_fields]="detail_config.fields" [OBJ_parent_form_group]="main_form_group" [STR_form_group_name]="field.name"></tig-tabs-publicationobjects>
							</tab>

							<tab *ngIf="(field.type === 'array_static' || field.type === 'object') && field.tab">
								<ng-template tabHeading><i class="fa tig-{{field.name.toLowerCase()}}"></i><span class="tig-title">{{helper_service.getLabelName(field)|translate}}</span></ng-template>
								<tig-tabs-dynamic-form [OBJ_field_config]="field" [OBJ_parent_form_group]="main_form_group" [STR_form_group_name]="field.name"></tig-tabs-dynamic-form>
							</tab>
						</ng-container>
					</tabset>
				</div>
				<accordion *ngIf="development">
					<accordion-group [panelClass]="'panel-danger'">
						<button type="button" (click)="debugFunctionUpdateData()"> Update Backend Data (Without Validation)</button>
						<div accordion-heading><i class="fa fa-angle-down"></i> Backend-Daten</div>
						<pre>{{updated_data | json}}</pre>
					</accordion-group>
					<accordion-group [panelClass]="'panel-danger'">
						<button type="button" (click)="debugFunctionAssignments()"> Update seperately saved Assignments (Without Validation)</button>
						<div accordion-heading><i class="fa fa-angle-down"></i> Assignments</div>
						<pre>{{save_seperately | json}}</pre>
					</accordion-group>
				</accordion>
				<accordion *ngIf="development">
					<accordion-group [panelClass]="'panel-danger'">
						<div accordion-heading><i class="fa fa-angle-down"></i> Formular Valide/Dirty?</div>
						<div>
							<div>Valid? : {{main_form_group.valid}}</div>
							<div>Dirty? : {{main_form_group.dirty}}</div>
							<div>Touched? : {{main_form_group.touched}}</div>
						</div>
					</accordion-group>
				</accordion>
			</div>
		</div>
	</div>
</div>
